// extracted by mini-css-extract-plugin
module.exports = {"disabled":"usersTable_disabled__1c0R0","section_header":"usersTable_section_header__1tbuO","table_container":"usersTable_table_container__1glTL"};